module.exports = __webpack_public_path__ + "static/media/silder_fix_3.725c7c50.jpg";